@if (!api.loading_get_utilisateur && api.infos.utilisateur ) {
<div class="layout-wrapper layout-content-navbar">
  <div class="layout-container">
    <!-- Menu -->
    <app-sidebar></app-sidebar>
    <!-- / Menu -->

    <!-- Layout container -->
    <div class="layout-page">
      <!-- Navbar -->
      <app-navbar></app-navbar>
      <!-- <app-navbar [hidden]="api.hide_on_print"></app-navbar> -->

      <!-- / Navbar -->

      <!-- Content wrapper -->
      <div class="content-wrapper">
        <!-- Content -->

        <div class="container-fluid flex-grow-1 container-p-y">
          <router-outlet></router-outlet>
        </div>
        <!-- / Content -->

        <!-- Footer -->
        <!-- <app-footer></app-footer> -->
        <!-- / Footer -->

        <div class="content-backdrop fade"></div>
      </div>
      <!-- Content wrapper -->
    </div>
    <!-- / Layout page -->
  </div>

  <!-- Overlay -->
  <div class="layout-overlay layout-menu-toggle"></div>
  
</div>
}@else if (!api.loading_get_utilisateur && !api.infos.utilisateur) {
<div class="text-center m-5 p-5">Erreur de chargement des données de l'utilisateur</div>
}@else () {
  <div class="text-center my-5 py-5">
    <div class="loading-spinner">
      <div class="spinner"></div>
      <p class="text-muted mt-2">Chargement en cours...</p>
    </div>
  </div>
}


